import '../styles/SuccessAnimation.scss';

const SuccessAnimation = () => {
	return (
		<div className="success-animation">
			<div className="Mark">&#10003;</div>
		</div>
	);
};

export default SuccessAnimation;
